import { Box, Button, Grid, TextField } from '@mui/material';
import React from 'react';
import { TextInput } from 'components';

const CoinRateForm = ({ coinRate, isEditing, handleChange }) => (
	<Grid container spacing={1}>
		<Grid item xs={12} sm={12}>
			<TextInput
				value={coinRate.name}
				label="Name"
				name="name"
				placeholder="Name"
				handleChange={handleChange}
			/>
		</Grid>
		<Grid item xs={12} sm={12}>
			<TextInput
				value={coinRate.xp}
				label="XP"
				name="xp"
				placeholder="XP"
				type="number"
				handleChange={handleChange}
			/>
		</Grid>
		<Grid item xs={12} sm={12}>
			<TextInput
				value={coinRate.coins}
				label="Coins"
				name="coins"
				placeholder="Coins"
				handleChange={handleChange}
				type="number"
			/>
		</Grid>
	</Grid>
);

export default CoinRateForm;
